import { createFileRoute, redirect } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { legionellaSensorRoomMapQuery } from '@/queries/site-legionella-sensor-room-map.query'

export const Route = createFileRoute('/_dashboard/site/$id/sensor-plan/')({
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.SITE_DEVICES)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  loader({ params, context: { queryClient } }) {
    void queryClient.ensureQueryData(legionellaSensorRoomMapQuery(params.id))
  },
  pendingComponent: PendingComponent,
})
